export const SIGNUP_METHODS = {
    METAMASK: 'metamask',
    SERVER: 'server',
}
